import React, { useState, useEffect } from "react";
import { Grid, Select, FormControl, MenuItem, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";

// Images
import VRF from "../../assets/Images/VRF.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  formControl: {
    width: "max-content",
    minWidth: "100%",
    backgroundColor: "#eeeef5",
    fontFamily: "Arial",
    height: "6vh",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421",
    opacity: "1",
    borderRadius: "12px",
    height: "15vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 0",
  },
  cardHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    marginTop: "1vh",
    font: "normal normal medium 17px/60px Bw Seido Round",
    opacity: "1",
    fontWeight: "bold",
    fontSize: "1.7vh",
    textAlign: "center",
  },
  select: {
    fontWeight: "bold",
    height: "6vh",
    borderRadius: "0.8vw",
    fontFamily: "Arial",
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      fontSize: "2vh",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "12px",
    opacity: "1",
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();

  const [equipmentData, setEquipmentData] = useState({});
  const [selectedDevice, setSelectedDevice] = useState("");

  useEffect(() => {
    api.floor.cpmGetDevData().then((res) => {
      const vrfOnly = { NONGL_SS_VRF: res["NONGL_SS_VRF"] };
      setEquipmentData(vrfOnly);
      setSelectedDevice("");
    });
  }, []);

  const typeNameMap = {
    NONGL_SS_VRF: "Variable Refrigerant Flow",
  };

  const typeImageMap = {
    NONGL_SS_VRF: VRF,
  };

  const selectedType = "NONGL_SS_VRF";
  const devices = equipmentData[selectedType]
    ? Object.entries(equipmentData[selectedType]).sort((a, b) =>
        a[1].name.localeCompare(b[1].name)
      )
    : [];

  const handleDeviceChange = (e) => {
    setSelectedDevice(e.target.value);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {/* Optional Device Dropdown */}
        <Grid container item xs={12} spacing={2}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            style={{ marginLeft: "1vw" }}
          >
            <FormControl variant="filled" className={classes.formControl}>
              <Select
                value={selectedDevice}
                onChange={handleDeviceChange}
                disableUnderline
                className={classes.select}
                displayEmpty
              >
                <MenuItem value="">All Devices</MenuItem>
                {devices.map(([deviceId, deviceInfo]) => (
                  <MenuItem key={deviceId} value={deviceId}>
                    {deviceInfo.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Device Cards */}
        <Grid container item xs={12} spacing={2} style={{ marginTop: "2vh" }}>
          {devices
            .filter(
              ([deviceId]) =>
                selectedDevice === "" || selectedDevice === deviceId
            )
            .map(([deviceId, deviceInfo]) => {
              return (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={deviceId}>
                  <Card className={classes.paper} style={{ height: "44vh" }}>
                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: "left", marginLeft: "2vh" }}
                      >
                        <div
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "3vh",
                            marginLeft: "2vh",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.2",
                            textAlign: "left",
                          }}
                        >
                          {deviceInfo.name}
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      {/* Image */}
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={typeImageMap[selectedType]}
                          alt={typeNameMap[selectedType]}
                          style={{
                            width: "10vw",
                            height: "25vh",
                            objectFit: "contain",
                            marginTop: "3.5vh",
                            marginLeft: "5vh",
                          }}
                        />
                      </Grid>

                      {/* Attributes */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        style={{
                          overflowY:
                            Object.keys(deviceInfo.Eqp_Attributes || {})
                              .length > 4
                              ? "auto"
                              : "unset",
                          maxHeight:
                            Object.keys(deviceInfo.Eqp_Attributes || {})
                              .length > 4
                              ? "30vh"
                              : "unset",
                          paddingRight: "0.5vw",
                        }}
                      >
                        <Grid container spacing={1}>
                          {deviceInfo?.Eqp_Attributes &&
                            Object.entries(deviceInfo.Eqp_Attributes).map(
                              ([attrKey, attrValue]) => (
                                <Grid item xs={6} key={attrKey}>
                                  <Card className={classes.paper1}>
                                    <div className={classes.cardHeading}>
                                      {attrKey.replace(/_/g, " ")}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#0123B4",
                                        fontWeight: "bold",
                                        whiteSpace: "nowrap",
                                        marginBottom: "2vh",
                                      }}
                                    >
                                      {(() => {
                                        const val = attrValue.presentValue;

                                        if (attrKey.includes("AM_SS")) {
                                          return val === "active" || val === 1
                                            ? "Auto"
                                            : "Manual";
                                        } else if (attrKey.includes("RUN_SS")) {
                                          return val === "active" || val === 1
                                            ? "ON"
                                            : "OFF";
                                        } else if (attrKey.includes("On_Off")) {
                                          return val === "active" || val === 1
                                            ? "ON"
                                            : "OFF";
                                        } else if (
                                          attrKey.includes("Trip_SS_Alarm")
                                        ) {
                                          return val === "active" || val === 1
                                            ? "Tripped"
                                            : "Normal";
                                        } else if (
                                          attrKey.toLowerCase().includes("temp")
                                        ) {
                                          return !isNaN(parseFloat(val))
                                            ? `${parseFloat(val).toFixed(2)} °C`
                                            : val;
                                        } else {
                                          return isNaN(parseFloat(val))
                                            ? val
                                            : parseFloat(val).toFixed(2);
                                        }
                                      })()}
                                    </div>
                                  </Card>
                                </Grid>
                              )
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </div>
  );
}
